import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import denormalize from 'json-api-denormalizer'
import FilterBanner from '../../components/FilterBanner'
import { toggleValueInList } from '../../util'
import {
  selectCourseIds,
  selectSectionIds,
  selectStudentIds,
  selectUserUuids,
  selectStartingDate,
  selectEndingDate,
  selectContentTypes,
  commitFilters,
  revertFilters
} from './actions'

const FilterContainer = props =>{
  const { courses,sections, students,dateFilter, contentFilter } = props
  // Collections for dropdowns
  const getCourseCollection = ()=>
    _.map(courses, course =>({ value: course.id, label: course.name }))
  const getSectionCollection = ()=>
    _.map(sections, section =>({ value: section.id, label: section.name }))
  const getStudentCollection = ()=>
    _.orderBy(
      _.flatMap(sections, section =>
        _.map(section.students, student => ( {value: student.id, label: student.profile.first_name + " " + (student.profile.last_name ? student.profile.last_name : "") + " (from " + section.name + ")"}))
      ), student => [ student.label.split(' ')[1] ? student.label.split(' ')[1].toUpperCase() : null, student.label.split(' ')[0].toUpperCase() ]
    )
  const getContentTypes = ()=>
    [
      {value: 'sequence-quest', label: 'Sequence Quest'},
      {value: 'practice-quest', label: 'Practice Quest'},
      {value: 'enrichment-quest', label: 'Enrichment Quest'},
      {value: 'sandbox-unlock', label: 'Sandbox Unlock'}
    ]
  // Filter control manpulators
  const toggleCourseId = id =>
    props.dispatch(selectCourseIds(toggleValueInList(parseInt(id), props.selectedCourseIds)))
  const toggleSectionId = id =>
    props.dispatch(selectSectionIds(toggleValueInList(parseInt(id), props.selectedSectionIds)))
  const toggleStudentId = id => {
    const { students, dispatch, selectedStudentIds, selectedUserUuids } = props
    const foundUserUuid = (_.find(students, student => student.id == id) || {}).user_uuid
    dispatch(selectStudentIds(toggleValueInList(parseInt(id), selectedStudentIds)))
    dispatch(selectUserUuids(toggleValueInList(foundUserUuid, selectedUserUuids)))
  }
  const dispatchSelectStartingDate = date =>
    props.dispatch(selectStartingDate(date))
  const dispatchSelectEndingDate = date =>{
    props.dispatch(selectEndingDate(date))
  }
  const dispatchSelectContentTypes = contentTypes =>
    props.dispatch(selectContentTypes(contentTypes))
  const toggleContentType = contentType =>
    props.dispatch(selectContentTypes(toggleValueInList(contentType , props.selectedContentTypes)))
  const applyFilters = ()=>
    props.dispatch(commitFilters())
  const cancelFilters = ()=>
    props.dispatch(revertFilters())
  const toggleCommittedCourseId = id => {
    const newIds = toggleValueInList(parseInt(id), props.selectedCourseIds)
    props.dispatch(selectCourseIds(newIds))
    props.dispatch(commitFilters())
  }
  const toggleCommittedSectionId = id => {
    const newIds = toggleValueInList(parseInt(id), props.selectedSectionIds)
    props.dispatch(selectSectionIds(newIds))
    props.dispatch(commitFilters())
  }
  const toggleCommittedStudentId = id => {
    const { students, dispatch, selectedStudentIds, selectedUserUuids } = props
    const foundUserUuid = (_.find(students, student => student.id == id) || {}).user_uuid

    dispatch(selectStudentIds(toggleValueInList(parseInt(id), selectedStudentIds)))
    dispatch(selectUserUuids(toggleValueInList(foundUserUuid, selectedUserUuids)))
    dispatch(commitFilters())
  }
  const toggleCommittedContentType = contentType => {
    const newTypes = toggleValueInList(contentType, props.selectedContentTypes)
    props.dispatch(selectContentTypes(newTypes))
    props.dispatch(commitFilters())
  }
  const removeCommittedDateFilters = ()=> {
    props.dispatch(selectStartingDate(''))
    props.dispatch(selectEndingDate(''))
    props.dispatch(commitFilters())
  }

  return(
    <FilterBanner
      courseCollection={getCourseCollection()}
      sectionCollection={getSectionCollection()}
      studentCollection={getStudentCollection()}
      contentTypes={getContentTypes()}
      selectedCourseIds={props.selectedCourseIds}
      selectedSectionIds={props.selectedSectionIds}
      selectedStudentIds={props.selectedStudentIds}
      selectedStartingDate={props.selectedStartingDate}
      selectedEndingDate={props.selectedEndingDate}
      selectedContentTypes={props.selectedContentTypes}
      committedCourseIds={props.committedCourseIds}
      committedSectionIds={props.committedSectionIds}
      committedStudentIds={props.committedStudentIds}
      committedStartingDate={props.committedStartingDate}
      committedEndingDate={props.committedEndingDate}
      committedContentTypes={props.committedContentTypes}
      removeCommittedDateFilters={removeCommittedDateFilters}
      toggleCourseId={toggleCourseId}
      toggleSectionId={toggleSectionId}
      toggleStudentId={toggleStudentId}
      toggleContentType={toggleContentType}
      toggleCommittedCourseId={toggleCommittedCourseId}
      toggleCommittedSectionId={toggleCommittedSectionId}
      toggleCommittedStudentId={toggleCommittedStudentId}
      toggleCommittedContentType={toggleCommittedContentType}
      selectStartingDate={dispatchSelectStartingDate}
      selectEndingDate={dispatchSelectEndingDate}
      onApply={applyFilters}
      onCancel={cancelFilters}
      hasDateFilter={dateFilter}
      hasContentFilter={contentFilter}
    />
  )
}

const mapStateToProps = state =>{
  const denormalizedState = denormalize(state.api || {})
  const {
    selectedCourseIds,
    selectedSectionIds,
    selectedStudentIds,
    selectedUserUuids,
    selectedStartingDate,
    selectedEndingDate,
    selectedContentTypes,
    committedCourseIds,
    committedSectionIds,
    committedStudentIds,
    committedUserUuids,
    committedStartingDate,
    committedEndingDate,
    committedContentTypes
  } = state.filter

  return {
    filterValues: state.filter,
    courses: denormalizedState.courses,
    sections: denormalizedState.sections,
    students: denormalizedState.students,
    selectedCourseIds,
    selectedSectionIds,
    selectedStudentIds,
    selectedUserUuids,
    selectedStartingDate,
    selectedEndingDate,
    selectedContentTypes,
    committedCourseIds,
    committedSectionIds,
    committedStudentIds,
    committedUserUuids,
    committedStartingDate,
    committedEndingDate,
    committedContentTypes
  }
}

export default connect(mapStateToProps)(FilterContainer)
